// removed by extract-text-webpack-plugin
module.exports = {"link":"_1O6rLRkWNcQllRxi9rA8YB"};